import { IUsersRequestDTO, IPaginatedUsersDTO } from 'src/api/dtos';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';

export default class UsersRepository extends CommonRepository {
  private static readonly baseRoute = '/users';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getUsers: build.query<IPaginatedUsersDTO, IUsersRequestDTO>({
        query: (params) => {
          return { url: this.apiURL, method: 'get', params };
        },
        providesTags: ['Users'],
      }),
    }),
  });
}
